import dayjs from 'dayjs'
import 'dayjs/locale/th'

const customParseFormat = require('dayjs/plugin/customParseFormat')
const buddhistEra = require('dayjs/plugin/buddhistEra')

dayjs.extend(buddhistEra)
dayjs.extend(customParseFormat)